import React from 'react';
import { Article } from '../../../../types/items';
import ActivityProjectStatusComment from './comments/ActivityProjectStatusComment';
import ActivityOrderComment from './comments/ActivityOrderComment/ActivityOrderComment';
import ActivityMessageComment from './comments/ActivityMessageComment';
import ActivityOrderStatusComment from './comments/ActivityOrderStatusComment';

type Props = {
  article: Article;
};

const ActivityComment = ({ article }: Props) => {

  if (article.ref.is_project_status_change
    && article.ref.project_status
    && article.order_id < 0) {
    return <ActivityProjectStatusComment article={article} />;
  }

  if (article.is_general_comment && article.order_status === 'cancelled' && article.ref.order) {
    return <ActivityOrderStatusComment article={article} />;
  }

  if (article.order_id > 0 && article.ref.order && article.ref.order.status_id) {
    return <ActivityOrderComment article={article} />;
  }

  if (article.is_general_comment && article.message) {
    return <ActivityMessageComment article={article} />;
  }

  return null;
};

export default ActivityComment;
